/* This is generated code, don't alter */
var IfcCondenserTypeEnum;
(function (IfcCondenserTypeEnum) {
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["AIRCOOLED"] = 0] = "AIRCOOLED";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["EVAPORATIVECOOLED"] = 1] = "EVAPORATIVECOOLED";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["WATERCOOLED"] = 2] = "WATERCOOLED";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["WATERCOOLEDBRAZEDPLATE"] = 3] = "WATERCOOLEDBRAZEDPLATE";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["WATERCOOLEDSHELLCOIL"] = 4] = "WATERCOOLEDSHELLCOIL";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["WATERCOOLEDSHELLTUBE"] = 5] = "WATERCOOLEDSHELLTUBE";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["WATERCOOLEDTUBEINTUBE"] = 6] = "WATERCOOLEDTUBEINTUBE";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcCondenserTypeEnum[IfcCondenserTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcCondenserTypeEnum || (IfcCondenserTypeEnum = {}));
const IfcCondenserTypeEnumCount = 9;
export { IfcCondenserTypeEnum, IfcCondenserTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcCondenserTypeEnum = new Int32Array([4, -3, 16]);
let prefixSumAddressIfcCondenserTypeEnum = new Uint32Array([0, 12, 25, 44, 55, 77, 100, 124, 146, 159]);
let slotMapIfcCondenserTypeEnum = new Int32Array([8, 2, 1, 0, 4, 6, 3, 5, 7]);
let encodedDataIfcCondenserTypeEnum = (new TextEncoder()).encode(".NOTDEFINED..WATERCOOLED..EVAPORATIVECOOLED..AIRCOOLED..WATERCOOLEDSHELLCOIL..WATERCOOLEDTUBEINTUBE..WATERCOOLEDBRAZEDPLATE..WATERCOOLEDSHELLTUBE..USERDEFINED.");
let IfcCondenserTypeEnumSearch = new MinimalPerfectHash(gMapIfcCondenserTypeEnum, prefixSumAddressIfcCondenserTypeEnum, slotMapIfcCondenserTypeEnum, encodedDataIfcCondenserTypeEnum);
export { IfcCondenserTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcCondenserTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcCondenserTypeEnumSearch, input, cursor, endCursor);
}
